import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import Card from 'material-ui/Card';
import './index.scss';
import { projectSelectedStyle } from '../../constants/theme'
import {observer,inject} from 'mobx-react';

@inject("projectDataStore")
@observer
class PlanItem extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    setSelectItem(id) {
        this.props.projectDataStore.isSelectPlan(id);
    }

    render() {
        const { planData, isSelect } = this.props
        return (
            <Card className='projectItem'
                  style={isSelect ? projectSelectedStyle : null}
                  onClick={() => this.setSelectItem(planData.id)}>
                <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={12} spacing={16}>
                        <img src={planData.imgUrl} alt='img' className='imgProject'></img>
                        <br/>
                        <span className='nameProj'> {planData.title} </span>
                        <br/>
                        <span className='addProj'> {planData.area} ตร.ม.</span>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

export default PlanItem;


// WEBPACK FOOTER //
// ./src/components/wizard/planItem.js